module.exports = __webpack_public_path__ + "static/img/7.902fd871.png";